import { render, staticRenderFns } from "./MoveProjectDialog.vue?vue&type=template&id=67c39830&scoped=true"
import script from "./MoveProjectDialog.vue?vue&type=script&lang=js"
export * from "./MoveProjectDialog.vue?vue&type=script&lang=js"
import style0 from "./MoveProjectDialog.vue?vue&type=style&index=0&id=67c39830&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c39830",
  null
  
)

export default component.exports